import { useMemo } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { ValkyrieQueueConsumerListEditor } from 'config-editor';
import type { ValkyrieLambda, SqsQueue } from 'config-editor-common';
import { useRecordField } from '../fieldState';

type Props = FieldExtensionComponentProps<Record<string, ValkyrieLambda>>;

export const ValkyrieQueueConsumerEditor = (props: Props) => {
  const { items, rootFormData, commit } = useRecordField<ValkyrieLambda>(props);

  const queueNames = useMemo(() => {
    const queues = rootFormData?.sqs_queues;
    if (!Array.isArray(queues)) return [];
    return (queues as SqsQueue[]).map(q => q.name).filter(Boolean) as string[];
  }, [rootFormData]);

  return (
    <ValkyrieQueueConsumerListEditor lambdas={items} onChange={commit} queueNames={queueNames} />
  );
};
